<script>
import { defineComponent } from '@vue/composition-api';
import { format } from 'date-fns';
import { useManagerDashboard } from '../../composables/useManagerDashboard';

export default defineComponent({
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    iconIsText: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => '',
    },
    startDate: {
      type: String,
      default: () => '',
    },
    endDate: {
      type: String,
      default: () => '',
    },
    contactsSent: {
      type: Number,
      default: () => null,
    },
    totalContacts: {
      type: Number,
      default: () => null,
    },
    sentPercentage: {
      type: Number,
      default: () => null,
    },
    status: {
      type: String,
      default: () => '',
    },
    tooltipText: {
      type: String,
      default: () => null,
    },
  },
  setup() {
    const { toggleCampaignDialog, changeCurrentCampaign, formatNumber } = useManagerDashboard();
    const formatDate = (d) => format(d, 'DD/MM/YYYY');
    const selectCampaign = (campaign) => {
      changeCurrentCampaign(campaign);
      toggleCampaignDialog();
    };

    return {
      formatNumber,
      formatDate,
      selectCampaign,
    };
  },
});
</script>

<template>
  <v-layout
    row
    align-baseline
    class="mb-4 campaign-data"
  >
    <v-flex xs2>
      <v-avatar
        color="primary"
        class="mr-4 campaign-data__avatar"
        size="31pt"
      >
        <v-icon
          size="14pt"
          style="color: white"
        >
          {{ status === "COMPLETE" ? "mdi-check-bold" : "mdi-bell-ring" }}
        </v-icon>
      </v-avatar>
    </v-flex>
    <v-flex auto>
      <div>
        <v-layout
          align-baseline
          row
        >
          <v-flex>
            <div class="campaign-data__title">
              {{ title }}
            </div>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              class="text-capitalize"
              icon
              size="31pt"
              @click="selectCampaign(campaign)"
            >
              <v-icon :size="20">
                keyboard_arrow_right
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <v-layout
        class="campaign-data__info"
        row
        wrap
      >
        <v-flex grow>
          Início: {{ formatDate(startDate) }}
          Fim:  {{ formatDate(endDate) }}
        </v-flex>
      </v-layout>
      <v-progress-linear
        :color="sentPercentage < 0.7 ? '#FF5146' : '#6ADDC8'"
        background-color="#DDDDDD"

        height="7"
        :value="formatNumber((sentPercentage) * 100)"
      />
      <div class="campaign-data__info">
        {{ formatNumber(contactsSent) }}
        de {{ formatNumber(totalContacts) }} contatos ({{ formatNumber(Math.floor((sentPercentage) * 100)) }}%)
      </div>
    </v-flex>
  </v-layout>
</template>
<style lang="scss" scoped>
.campaign-data {
  &__title {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  }
  &__info {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 8px;
  }
  &__avatar {
    margin-top: 12.5pt
  }
}
.v-progress-linear {
  margin-top: 5.5pt;
  margin-right: 0px;
  margin-bottom: 5.5pt;
  margin-left: 0px;
}
::v-deep .v-progress-linear {
  border-radius: 16px !important;
}
.v-avatar {
  border-radius: 30%;
}
</style>
